import fuzzydate from 'util/fuzzydate';

import usePollingRerender from './usePollingRerender';

/**
 * Return an auto-updating fuzzy version of the input date.
 *
 * @note This will cause the calling component to rerender every second.
 */
export default function useFuzzyDate(date: string): string {
  usePollingRerender(1000);
  return fuzzydate(date);
}
